import FontFaceObserver from 'fontfaceobserver';
import imagesLoaded from 'imagesloaded';
import { debounce } from 'underscore'
import 'focus-visible';
import sayHello from './lib/sayHello';
import './global';
import scroll from './locoScroll';
import header from './header';
import './animatedRows';
import museumSlider from './museumSlider';
import labSlider from './labSlider';
import stageSlider from './stageSlider';
import './validationForm';
import BubbleManager from './bubleLink';
import './googleMap';
import './footer';

sayHello();

window.addEventListener('load', () => {
  museumSlider.init();
  labSlider.init();
  stageSlider.init();  

  const buble = document.querySelector('.buble');
  const bubbleManager = new BubbleManager(buble, document.querySelectorAll('.js-buble-link'))
  // [...document.querySelectorAll('.js-buble-link')].forEach(link => {const bubbleLink = new BubbleLink({
  //   link, 
  //   buble
  // })})

})

document.documentElement.addEventListener('bigHeightResize', debounce(() => {
  museumSlider.resize();
  labSlider.resize();
  stageSlider.resize();

  setTimeout(() => {
    scroll.update();
  }, 100)
  
}, 300))

const links = [...document.querySelectorAll('.js-anchor')];
links.forEach(link => {
  link.addEventListener('click', event => {
    event.preventDefault();

    const id = event.target.hash; // with # | Example: #section-id
    const target = document.querySelector(id);
    
    scroll.scrollTo(target);

    if (header.isOpen) header.close();
  })
})
